exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/dettaglio/dettaglio-immagine-battezzato.component.css
// module id = ../../../../../src/app/dettaglio/dettaglio-immagine-battezzato.component.css
// module chunks = main